import React from 'react'

import { Typography } from '@mui/material'

const NotEnabled = () => (
  <Typography color="text.secondary" variant="body2">
    Not enabled
  </Typography>
)

export default NotEnabled
